module.exports = __webpack_public_path__ + "static/img/6-1-2.45a0cc34.jpg";